import { render, staticRenderFns } from "./SettingsBotThemeEditor.vue?vue&type=template&id=34a694c2&scoped=true&"
import script from "./SettingsBotThemeEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsBotThemeEditor.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBotThemeEditor.vue?vue&type=style&index=0&id=34a694c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a694c2",
  null
  
)

export default component.exports